import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './logcdf.js';
import __var_2__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Evaluate the natural logarithm of the cumulative distribution function (CDF) for a Kumaraswamy's double bounded distribution.
*
* @module @stdlib/stats/base/dists/kumaraswamy/logcdf
*
* @example
* var logcdf = require( '@stdlib/stats/base/dists/kumaraswamy/logcdf' );
*
* var y = logcdf( 0.5, 1.0, 1.0 );
* // returns ~-0.693
*
* y = logcdf( 0.5, 2.0, 4.0 );
* // returns ~-0.38
*
* @example
* var factory = require( '@stdlib/stats/base/dists/kumaraswamy/logcdf' ).factory;
*
* var logcdf = factory( 0.5, 0.5 );
*
* var y = logcdf( 0.8 );
* // returns ~-0.393
*
* y = logcdf( 0.3 );
* // returns ~-1.118
*/

// MODULES //
var setReadOnly = __var_0__;
var logcdf = __var_1__;
var factory = __var_2__;


// MAIN //

setReadOnly( logcdf, 'factory', factory );


// EXPORTS //
export default logcdf;
